import Vue from "vue";
import pokerVue from "./poker.vue";
import mahjongVue from "./mahjong.vue";
import merge from "@/utils/merge";

const defaults = {
    data: []
};

let SmallGameConstructor = null;
//MiniGameId 7000是扑克，7001是麻将
//options  {MiniGameId: jsonData.MiniGameId,WinPos: jsonData.WinPos,WinGold: jsonData.WinGold,ResultList: jsonData.ResultList,Bet: jsonData.Bet}

const SmallGame = options => {
    options = merge({}, defaults, options);
    if (options.MiniGameId == 7000) {
        SmallGameConstructor = Vue.extend(pokerVue);
    }
    if (options.MiniGameId == 7001) {
        SmallGameConstructor = Vue.extend(mahjongVue);
    }
    if (SmallGameConstructor != null) {
        let instance = new SmallGameConstructor({
            data: options
        });
        instance._vm = instance.$mount();
        instance._el = instance.$el;
        instance._instance = instance;
        document.body.appendChild(instance.$el); // 把生成的提示的dom插入body中
        return instance;
    } else {
        return null;
    }
};

export default SmallGame;